<template>
  <div>
      <div class="img img-responsive center">
         <img src="../../assets/registration-closed.png" alt="registration closed">
      </div>
  </div>
</template>

<script>
export default {
name: 'registrationClosed',
}
</script>

<style  scoped>

.center{
  margin : 50px auto ;
  width : 400px;
  
}
@media screen and (max-width : 400px) {
  .center{
  margin : 50px auto ;
  width : 200px;
  
} 
.center img {
  width : 200px;
  object-fit: cover;
}
}

</style>

